export default __webpack_public_path__ + "static/media/rounded-rectangle.ffc80e4e.svg";